module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-144x144-b4a61a3582df6257ed5e03559b796b05.png";